export default __webpack_public_path__ + "static/Group 70-930f592bba2dedab0e8475686c892b73.jpg";